/**
 * Check if device is on iOS platform
 * @see: https://stackoverflow.com/a/58065241/622287
 * @type {Boolean}
 */
export const isIOS =
  (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream;

/**
 * Check for safari browser
 * @see: https://stackoverflow.com/a/31732310/622287
 * @type {Boolean}
 */
export const isSafari =
  navigator.vendor &&
  navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;

/**
 * Check if is mobile device
 * @see: https://g.co/gemini/share/dc58816f11dd
 * @return {Boolean}
 */
export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Simplified Test: Using keywords common in mobile user agent strings
  if (/\b(Android|iPhone|iPad|iPod|Windows Phone|BlackBerry)\b/i.test(userAgent)) {
    return true;
  }

  // Touch Detection: A more reliable way to identify many mobile devices
  if (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  ) {
    return true;
  }

  return false;
};
